import { Component } from "react";
import { Link } from "react-router-dom";
import { IoMail } from "react-icons/io5";
import { FaPhoneAlt } from "react-icons/fa";
import { FaLocationDot } from "react-icons/fa6";
import "./index.css";

class Footer extends Component {
  render() {
    return (
      <section className="footer-container">
        <div className="footer-content-container">
          <div className="footer-sections-container">
            <div className="footer-card-container">
              <div className="footer-logo-content">
                <Link to="/">
                  <img
                    src="/simple-trash-solutions-logo.webp"
                    alt="website logo"
                    className="footer-logo-img"
                  />
                </Link>
                <p>
                  Efficient door-to-door trash collection for apartment
                  complexes in Peoria, IL, and nearby cities.
                </p>
              </div>
            </div>
            <div className="footer-card-container quick-links">
              <h1 className="footer-headings">Quick Links</h1>
              <ul className="footer-list-items">
                <li>
                  <Link to="/" className="Link">
                    <p>Home</p>
                  </Link>
                </li>

                <li>
                  <Link to="/about-us" className="Link">
                    <p>About Us</p>
                  </Link>
                </li>

                <li>
                  <Link to="/faqs" className="Link">
                    <p>FAQs</p>
                  </Link>
                </li>
              </ul>
            </div>
            <div className="footer-card-container">
              <h1 className="footer-headings">Services</h1>
              <ul className="footer-list-items">
                <li>Door-to-Door Pickup</li>
                <li>Hallway Steam Cleaning</li>
                <li>Bin Rentals</li>
                <li>Dumpster Exterior Cleaning</li>
                <li>Monthly Garbage Bag Provided</li>
                <li>Dog Park Waste Cleanup</li>
              </ul>
            </div>
            <div className="footer-card-container footer-contact-container-card">
              <h1 className="footer-headings">Contact Us</h1>
              <ul className="footer-list-items contact-list-item-con">
                <li className="contact-aligment-container">
                  <IoMail className="footer-icon" />
                  <Link
                    to="mailto:ssmothers@simpletrashsolutionsllc.com"
                    target="_blank"
                  >
                    <p>ssmothers@simpletrashsolutionsllc.com</p>
                  </Link>
                </li>
                <li className="contact-aligment-container">
                  <FaPhoneAlt className="footer-icon" />
                  <p>309-643-7152</p>
                </li>
                <li className="contact-aligment-container">
                  <FaLocationDot className="footer-icon" />
                  <p>1929 East Princeton St Peoria, IL</p>
                </li>
              </ul>
            </div>
          </div>
          <hr className="hr-line" />
          <div className="copy-rights-container">
            Copyrights &copy; 2024 Simple Trash Solutions. All rights reserved |
            Developed by{" "}
            <Link
              to="https://www.linkedin.com/in/prasanya-shankar/"
              className="my-name"
              target="_blank"
            >
              Prasanya Shankar
            </Link>
          </div>
        </div>
      </section>
    );
  }
}

export default Footer;
